/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { css } from 'glamor';
import { times } from 'lodash';

type Props = {
  numTabs: number,
  height: number,
};

const Wrapper = glamorous.div(({ height }) => ({
  display: 'flex',
  height,
  alignItems: 'stretch',
}));

const pulse = css.keyframes({
  '0%': {
    opacity: 0,
  },
  '25%': {
    opacity: 1,
  },
  '50%': {
    opacity: 0,
  },
  '100%': {
    opacity: 0,
  },
});

const LoadingTab = glamorous.div(
  {
    margin: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'stretch',
    flexGrow: 1,
  },
  ({ theme, height }) => ({
    backgroundColor: theme.color.panel,
    borderLeft: `1px solid ${theme.color.basis2}`,
    color: theme.color.basis5,
    height,
  }),
);

const LoadingTabInner = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.basis3,
  animation: `${pulse} 3s infinite`,
  width: '100%',
  height: '100%',
}));

function LoadingTabs({ numTabs, height }: Props) {
  return (
    <Wrapper height={height}>
      {times(numTabs).map(i => (
        <LoadingTab key={i}>
          <LoadingTabInner style={{ animationDelay: `${i * (3 / numTabs)}s` }} />
        </LoadingTab>
      ))}
    </Wrapper>
  );
}

export default LoadingTabs;
